import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Contract } from "../../../model/contract";

@Component({
  selector: 'aw-add-boxes-dialog',
  templateUrl: './add-boxes-dialog.component.html',
  styleUrls: ['./add-boxes-dialog.component.scss']
})
export class AddBoxesDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Contract,
    public dialogRef: MatDialogRef<AddBoxesDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


